import { ButtonsGroup } from '@billy/design-system'
import styled from '@emotion/styled'

export const ActionWrapper = styled(ButtonsGroup)`
  justify-content: flex-end;
`
